/* Progressive enhancement only: links and Shopify forms work without JavaScript. */
if (!window.murmurEd18Loaded) {
  window.murmurEd18Loaded = true;
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.me-menu[open]');
    if (menu) { menu.open = false; menu.querySelector('summary')?.focus(); }
  });
  document.addEventListener('click', (event) => {
    const menu = document.querySelector('.me-menu[open]');
    if (!menu || menu.contains(event.target)) return;
    menu.open = false;
  });
}
